export const zIndex = {
    badge: 'auto',
    tableFixed: 2,
    // 4-8 reserved for user
    affix: 10,
    backTop: 10,
    pickerPanel: 10,
    popupClose: 10,
    // 20-900 reserved for user
    header: 950,
    modal: 1000,
    modalMask: 1000,
    message: 1010,
    notification: 1010,
    popover: 1030,
    dropdown: 1050,
    picker: 1050,
    popoconfirm: 1060,
    tooltip: 1070,
    image: 1080,
    // 1100-2000 reserved for user
};
//# sourceMappingURL=zIndex.js.map